import axios from 'axios'
import { xsrfTokenInterceptor } from '@fe-toolkit/axios-api-toolkit'
import getConfig from 'next/config'

const { publicRuntimeConfig, serverRuntimeConfig } = getConfig()

const baseURL =
  typeof window === 'object'
    ? publicRuntimeConfig.API_GATEWAY_URL
    : serverRuntimeConfig.INTERNAL_API_GATEWAY_URL

const apiClient = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 10000,
})

apiClient.interceptors.request.use(config => xsrfTokenInterceptor({ config }))

export default apiClient
